import Navigation from '../components/navbar/Navigation';
import { useState } from 'react';
import { calcDISC } from '../calculators/calcDISC';
import InputDISC from '../components/input/InputDISC';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import { tips } from '../data/DISC/tips';
import { overallRelations, colors } from '../data/DISC/overallRelations';
import { taskCompatibility } from '../data/DISC/taskCompatibility';
import InfoAlert from '../components/InfoAlert';
import InfoCard from '../components/InfoCard';
import AdaptGuide from '../components/DISC/AdaptGuide';
import SubtraitsGuide from '../components/DISC/SubtraitsGuide';
import Disclaimer from '../components/Disclaimer';
// import Scale from '../components/Scale';
import scalePic from '../components/wallpaper.png';

function PageDISC() {
  const [personA, setPersonA] = useState(1);
  const handleChangePersonA = (personA) => setPersonA(personA);
  const [personB, setPersonB] = useState(1);
  const handleChangePersonB = (personB) => setPersonB(personB);
  let relationTypeDISC = calcDISC(personA, personB);
  const [showScale, setShowScale] = useState(false);
  function handleClick() {
    setShowScale(!showScale);
  }
  //   const colorsTask = [
  //     '#f5d7ce',
  //     '#f5cec1',
  //     '#e6c0b3',

  //     '#e8e4b3',
  //     '#e9ebb7',
  //     '#e0e8ac',

  //     '#d5e8ac',
  //     '#d7eda6',
  //     '#caeda6',

  //     '#caeda6',
  //     '#a6d2ed',
  //     '#95bbe8'
  // ]
  return (
    <div className='bg-light font-link' >
      <Navigation loc='top' />
      <Container style={{ paddingTop: '150px' }} >
        {/* Input here */}
        <Card className='bg-dark h-75 py-5 rounded-5 text-center text-light h1'>
          <b>Person A</b>
          <InputDISC value={personA} name='option1' handleChange={handleChangePersonA} />
          <b>Person B</b>
          <InputDISC value={personB} name='option2' handleChange={handleChangePersonB} />
        </Card>

        {/* Tips and task compatibility */}

        <Row className="justify-content-md-center py-4" lg={3} >
          <InfoAlert variant='success' head='Compatibility Tips' body={tips[relationTypeDISC].body} />
          <InfoAlert variant='light' /*color={colorsTask[relationTypeDISC]}*/ head='Task Compatibility' body={taskCompatibility[relationTypeDISC].body} />
        </Row>

        {/* Info about relation */}
        <div className='d-flex'>
          {
          showScale && 
          <div className='d-flex flex-column text-center'>
          <p style={{fontSize:'14px',fontWeight:'800'}}>WEAK → STRONG</p>
          <div className='d-flex flex-column justify-content-center' >
            <img fluid = 'true'
              className='rounded float-end '
              src={scalePic}
              alt="scale"
              height='120px'
            />
          </div>
          </div>
          }

          <InfoCard
            style={{ width: '75%', margin: 'auto', textAlign: 'center', backgroundColor: colors[relationTypeDISC].bg, color: colors[relationTypeDISC].text }}
            head={overallRelations[relationTypeDISC].head}
            body={overallRelations[relationTypeDISC].body}
            handleClick={handleClick}
            scale={true}
          />
          </div>


        {/* Adapt guide */}
        <div className='py-5'>
          <AdaptGuide rel={relationTypeDISC} />
        </div>

        {/* Sub traits guide */}
        <Container className=''>
          <SubtraitsGuide />
        </Container>
        <Disclaimer />
        {/* <Scale/> */}
      </Container>
    </div>
  );
}

export default PageDISC;
